module.exports = __webpack_public_path__ + "static/media/icon-change-ingredient-active.d8d8b978.svg";